import BaseApi from './base-api'
import { requirePublicApiBaseUrl } from '@/configs/api'

export const siteApi = new BaseApi({ baseURL: requirePublicApiBaseUrl() })
